var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -1 24 24",
    width: 48,
    height: 48,
    "aria-label": "Wsparcie po sprzeda\\u017Cy",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#52d552",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 13v-1a8 8 0 0 1 16 0v1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.2,
    y: 13.5,
    width: 3.6,
    height: 3.6,
    rx: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.2,
    y: 13.5,
    width: 3.6,
    height: 3.6,
    rx: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10v1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 10v1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.74bed585bfb3ffcded8996d6f131095f.svg";
export { ForwardRef as ReactComponent };